module.exports = __webpack_public_path__ + "static/img/s-apple-3.22a1ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-apple-3.png
// module id = Ng0s
// module chunks = 1